var React = require('react');

function CircleTick (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13 22C7.48372 22 3 17.5163 3 12C3 6.48372 7.48372 2 13 2C18.5163 2 23 6.48372 23 12C23 17.5163 18.5163 22 13 22Z","key":0}),React.createElement("path",{"d":"M11.8275 15.9175C11.6275 15.9175 11.4375 15.8375 11.2975 15.6975L8.4675 12.8675C8.1775 12.5775 8.1775 12.0975 8.4675 11.8075C8.7575 11.5175 9.2375 11.5175 9.5275 11.8075L11.8275 14.1075L16.9675 8.9675C17.2575 8.6775 17.7375 8.6775 18.0275 8.9675C18.3175 9.2575 18.3175 9.7375 18.0275 10.0275L12.3575 15.6975C12.2175 15.8375 12.0275 15.9175 11.8275 15.9175Z","fill":"white","key":1})]);
}

CircleTick.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = CircleTick;

CircleTick.default = CircleTick;
